const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import ECheckinForm from 'App/config/com/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/com/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: undefined,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.cistec.com',
        loginHelp: 'https://www.cistec.com/kontakt/',
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/7401d5e9-d9c3-4354-8442-ea96dafa154b/Children', // COM eCheckin Beruf
        Beziehung: 'Lookup/f6990d25-e657-48cb-8aeb-69dce793f4cc/Children', // COM eCheckin Beziehung
        Geschlecht: 'Lookup/3f20b7d6-03e9-4ef7-a016-e530dc893504/Children', // COM eCheckin Geschlecht
        Zivilstand: 'Lookup/44ba015d-120c-4ca1-903b-64842d61dea1/Children', // COM eCheckin Zivilstand
        Behandlungsgrund: 'Lookup/0b88ae62-d718-43d5-a923-bed65d36dedb/Children', // COM eCheckin Behandlungsgrund
        Versicherung: 'Lookup/c7e8dd9b-90c5-464f-abc7-406b84b1938d/Children', // COM eCheckin Versicherung
        Klasse: 'Lookup/d69c0fb2-bcf6-46f8-8746-2de047ac869e/Children', // COM eCheckin Klasse
    },
    customMatomoClientId: 1,
    bookAppointmentInfo: textMap.bookAppointmentInfoText,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: '7dbd66d9-939b-4216-b636-4194eb61f517',
};

export const { customMetaKatMultipleKeys } = configuration;
